// libs
import React from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
// widgets
import Tile from '@/widgets/Tile';
import CampaignTable from './components/Table';
// components
import FindCampaignButton from '@/widgets/FindCampaignButton';
import Tooltip from '@/components/Tooltip';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { IconInfo } from '@/constants/icons/svg';
import { DashboardTooltips } from '@/constants/tooltips';
// styles
import styles from './CampaignList.module.scss';
const CampaignList = ({ campaigns, isSearchPage }) => {
    return (React.createElement(Tile, { className: styles.tile },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.headerTitle },
                React.createElement(Text, { variant: DlsFontVariants.header_H4_Black, color: DlsColorTokens.text_Highest_Emphasis }, isSearchPage
                    ? `${campaigns.length} results found`
                    : `Active Campaigns`),
                !isSearchPage && (React.createElement(Tooltip, { content: DashboardTooltips.STALE_ACTIVE_CAMPAIGNS },
                    React.createElement(GenericIcon, { Icon: IconInfo, fillColor: DlsColorTokens.text_Low_Emphasis, className: styles.legendsTooltipIcon }))),
                !isSearchPage && React.createElement(FindCampaignButton, null)),
            !isSearchPage && (React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis }, "The data presented on this dashboard is subject to a 24-hour reporting delay. This delay is attributed to our data processing and validation procedures, which are implemented to ensure the accuracy and reliability of the information we provide."))),
        React.createElement("div", { className: styles.table },
            React.createElement(CampaignTable, { campaigns: campaigns, isSearchPage: isSearchPage }))));
};
export default CampaignList;
